import React from "react";

const QuranContextMenu = ({
  isOpen,
  contextMenu,
  uiLabels,
  onSelectTranslation,
  onSelectRecitation,
  onClose,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={`quran-context-menu ${
        contextMenu.verticalPlacement === "bottom" ? "quran-context-menu--bottom" : "quran-context-menu--top"
      } ${
        contextMenu.horizontalPlacement === "left"
          ? "quran-context-menu--left"
          : contextMenu.horizontalPlacement === "right"
            ? "quran-context-menu--right"
            : "quran-context-menu--center"
      }`}
      style={{ left: `${contextMenu.x}px`, top: `${contextMenu.y}px` }}
      onClick={(event) => event.stopPropagation()}
    >
      <button type="button" className="quran-context-btn" onClick={onSelectTranslation}>
        {uiLabels.translation}
      </button>
      <button type="button" className="quran-context-btn" onClick={onSelectRecitation}>
        {uiLabels.recitation}
      </button>
      <button type="button" className="quran-context-btn quran-context-btn-secondary" onClick={onClose}>
        {uiLabels.close}
      </button>
    </div>
  );
};

export default QuranContextMenu;